"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFetchAssetDocumentDownloadUrlMutation = exports.useDeleteAssetDocumentMutation = exports.useUpdateAssetDocumentMutation = exports.useUploadAssetDocumentMutation = exports.useDeleteAssetDocumentSectionMutation = exports.useRenameAssetDocumentSectionMutation = exports.useCreateAssetDocumentSectionMutation = exports.useFetchAssetDocumentArchiveQuery = exports.assetDocumentApi = void 0;
var react_1 = require("@reduxjs/toolkit/query/react");
var baseQueryWithReauth_1 = require("../../utils/baseQueryWithReauth");
exports.assetDocumentApi = (0, react_1.createApi)({
    reducerPath: "assetDocumentApi",
    baseQuery: (0, baseQueryWithReauth_1.baseQueryWithReauth)(process.env.LETS_CUE_API),
    tagTypes: ["asset_documents"],
    endpoints: function (builder) { return ({
        fetchAssetDocumentArchive: builder.query({
            query: function (obj) { return ({
                url: "/v1/asset-document/archive",
                method: "GET",
                params: { clientId: obj.clientId, buildingId: obj.buildingId, requestedBy: obj.requestedBy },
            }); },
            providesTags: ["asset_documents"],
        }),
        createAssetDocumentSection: builder.mutation({
            query: function (obj) { return ({ url: "/v1/asset-document/section", method: "POST", body: obj }); },
            invalidatesTags: ["asset_documents"],
        }),
        renameAssetDocumentSection: builder.mutation({
            query: function (obj) { return ({ url: "/v1/asset-document/section", method: "PUT", body: obj }); },
            invalidatesTags: ["asset_documents"],
        }),
        deleteAssetDocumentSection: builder.mutation({
            query: function (obj) { return ({ url: "/v1/asset-document/section", method: "DELETE", params: { sectionId: obj.sectionId } }); },
            invalidatesTags: ["asset_documents"],
        }),
        /** Upload a document, or — with `documentId` — a new version of one. */
        uploadAssetDocument: builder.mutation({
            query: function (obj) {
                var body = new FormData();
                body.append("clientId", obj.clientId);
                body.append("buildingId", obj.buildingId);
                body.append("sectionId", obj.sectionId);
                body.append("uploadedBy", obj.uploadedBy);
                if (obj.documentId)
                    body.append("documentId", obj.documentId);
                if (obj.name)
                    body.append("name", obj.name);
                if (obj.note)
                    body.append("note", obj.note);
                body.append("file", obj.file);
                return { url: "/v1/asset-document/upload", method: "POST", body: body };
            },
            invalidatesTags: ["asset_documents"],
        }),
        updateAssetDocument: builder.mutation({
            query: function (obj) { return ({ url: "/v1/asset-document/document", method: "PUT", body: obj }); },
            invalidatesTags: ["asset_documents"],
        }),
        deleteAssetDocument: builder.mutation({
            query: function (obj) { return ({ url: "/v1/asset-document/document", method: "DELETE", params: { documentId: obj.documentId } }); },
            invalidatesTags: ["asset_documents"],
        }),
        /**
         * Short-lived signed URL for one version. A mutation rather than a query on purpose: the URL
         * expires in 15 minutes, so caching it would hand out dead links.
         */
        fetchAssetDocumentDownloadUrl: builder.mutation({
            query: function (obj) { return ({
                url: "/v1/asset-document/download",
                method: "GET",
                params: __assign({ documentId: obj.documentId }, (obj.version ? { version: obj.version } : {})),
            }); },
        }),
    }); },
});
exports.useFetchAssetDocumentArchiveQuery = exports.assetDocumentApi.useFetchAssetDocumentArchiveQuery, exports.useCreateAssetDocumentSectionMutation = exports.assetDocumentApi.useCreateAssetDocumentSectionMutation, exports.useRenameAssetDocumentSectionMutation = exports.assetDocumentApi.useRenameAssetDocumentSectionMutation, exports.useDeleteAssetDocumentSectionMutation = exports.assetDocumentApi.useDeleteAssetDocumentSectionMutation, exports.useUploadAssetDocumentMutation = exports.assetDocumentApi.useUploadAssetDocumentMutation, exports.useUpdateAssetDocumentMutation = exports.assetDocumentApi.useUpdateAssetDocumentMutation, exports.useDeleteAssetDocumentMutation = exports.assetDocumentApi.useDeleteAssetDocumentMutation, exports.useFetchAssetDocumentDownloadUrlMutation = exports.assetDocumentApi.useFetchAssetDocumentDownloadUrlMutation;
